import { useIntl } from 'react-intl';
import { SelectButton } from 'primereact/selectbutton';
import { ServiceStatisticsGranularity } from '../../dto/ServiceStatisticsDTO';
import { GRANULARITIES } from './statisticsUtils';

interface GranularitySelectorProps {
    /** Distingue el rótulo cuando hay más de un selector en la pantalla. */
    id: string;
    value: ServiceStatisticsGranularity;
    onChange: (granularity: ServiceStatisticsGranularity) => void;
}

const LABEL_ID: Record<ServiceStatisticsGranularity, string> = {
    DAY: 'ServicesStatisticsGroupDay',
    WEEK: 'ServicesStatisticsGroupWeek',
    MONTH: 'ServicesStatisticsGroupMonth',
};

/**
 * "Agrupar por": el mismo dato de la evolución con un punto por día, semana o mes, por eso es un SelectButton. El rótulo
 * es solo el nombre accesible del grupo.
 */
export default function GranularitySelector({ id, value, onChange }: GranularitySelectorProps) {
    const intl = useIntl();
    const options = GRANULARITIES.map(granularity => ({
        value: granularity, label: intl.formatMessage({ id: LABEL_ID[granularity] }),
    }));
    return (
        <div className="ss-measure">
            <span id={id} className="nv-sr-only">{intl.formatMessage({ id: 'ServicesStatisticsGroupBy' })}</span>
            <SelectButton
                value={value}
                options={options}
                optionLabel="label"
                optionValue="value"
                onChange={e => { if (e.value) onChange(e.value); }}
                aria-labelledby={id}
            />
        </div>
    );
}
